(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var parcelRequire = $parcel$global["parcelRequire7c47"];
parcelRequire.register("hEqwf", function(module, exports) {
parcelRequire("1oeMt");
parcelRequire("3tZrP");

});
parcelRequire.register("1oeMt", function(module, exports) {

$parcel$export(module.exports, "validateHandle", function () { return $10337f8588923857$export$aa36166f0439dc76; });

var $61Fk6 = parcelRequire("61Fk6");

var $cH8J9 = parcelRequire("cH8J9");
const $10337f8588923857$var$formSelector = '[data-validate="jquery"]';
const $10337f8588923857$var$forms = document.querySelectorAll($10337f8588923857$var$formSelector);
$10337f8588923857$var$forms.forEach((form)=>{
    form.addEventListener("submit", (event)=>{
        let isValid = true;
        const inputsToValidate = form.querySelectorAll("[data-validators]:not(:disabled)");
        // Remove all validation mesagges before validating
        form.querySelectorAll(".validator").forEach((validatorMessage)=>validatorMessage.remove());
        form.querySelectorAll(".--invalid").forEach((input)=>input.classList.remove("--invalid"));
        const isInputsToValidate = ()=>inputsToValidate.length;
        if (isInputsToValidate()) inputsToValidate.forEach((inputToValidate)=>{
            const validatorsData = JSON.parse(inputToValidate.getAttribute("data-validators"));
            validatorsData.forEach((validator)=>{
                const { msg: msg = "" } = validator;
                const inputValue = inputToValidate.value;
                const result = $10337f8588923857$export$aa36166f0439dc76(validator, inputValue);
                if (!result) {
                    inputToValidate.after((0, $cH8J9.renderErrorMessage)(msg));
                    inputToValidate.closest(".f-text")?.classList.add("--invalid");
                    isValid = false;
                }
            });
        });
        if (!isValid) event.preventDefault(); // Prevent submit if form is not valid
    });
});
const $10337f8588923857$export$aa36166f0439dc76 = (validator, inputValue)=>{
    const { condition: validatorFunction, params: params = null } = validator;
    const validationsMethods = new (0, $61Fk6.FormValidationsCollection)();
    return validationsMethods[validatorFunction](inputValue, params);
};

});
parcelRequire.register("61Fk6", function(module, exports) {

$parcel$export(module.exports, "FormValidationsCollection", function () { return $4632e3fdd18d0891$export$801ffb0dc862c91a; });

var $1nkyL = parcelRequire("1nkyL");

var $9k9RZ = parcelRequire("9k9RZ");

var $eaU57 = parcelRequire("eaU57");

var $buU2k = parcelRequire("buU2k");

var $aSG46 = parcelRequire("aSG46");
class $4632e3fdd18d0891$export$801ffb0dc862c91a {
    required(value) {
        return !(0, $9k9RZ.default)(value);
    }
    maxLength(value, param) {
        return value.length <= param;
    }
    minLength(value, param) {
        return value.length >= param;
    }
    email(value) {
        return (0, $1nkyL.default)(value);
    }
    url(value) {
        return (0, $eaU57.default)(value);
    }
    float(value) {
        return (0, $buU2k.default)(value);
    }
    integer(value) {
        return (0, $aSG46.default)(value);
    }
}

});
parcelRequire.register("1nkyL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1007e3231928cbb8$export$2e2bcd8739ae039; });

var $i0YFF = parcelRequire("i0YFF");

var $SWroD = parcelRequire("SWroD");

var $8h7WX = parcelRequire("8h7WX");

var $aYOJs = parcelRequire("aYOJs");

var $bIal2 = parcelRequire("bIal2");
var $1007e3231928cbb8$var$default_email_options = {
    allow_display_name: false,
    require_display_name: false,
    allow_utf8_local_part: true,
    require_tld: true,
    blacklisted_chars: "",
    ignore_max_length: false,
    host_blacklist: [],
    host_whitelist: []
};
/* eslint-disable max-len */ /* eslint-disable no-control-regex */ var $1007e3231928cbb8$var$splitNameAddress = /^([^\x00-\x1F\x7F-\x9F\cX]+)</i;
var $1007e3231928cbb8$var$emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
var $1007e3231928cbb8$var$gmailUserPart = /^[a-z\d]+$/;
var $1007e3231928cbb8$var$quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
var $1007e3231928cbb8$var$emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
var $1007e3231928cbb8$var$quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
var $1007e3231928cbb8$var$defaultMaxEmailLength = 254;
/* eslint-enable max-len */ /* eslint-enable no-control-regex */ /**
 * Validate display name according to the RFC2822: https://tools.ietf.org/html/rfc2822#appendix-A.1.2
 * @param {String} display_name
 */ function $1007e3231928cbb8$var$validateDisplayName(display_name) {
    var display_name_without_quotes = display_name.replace(/^"(.+)"$/, "$1"); // display name with only spaces is not valid
    if (!display_name_without_quotes.trim()) return false;
     // check whether display name contains illegal character
    var contains_illegal = /[\.";<>]/.test(display_name_without_quotes);
    if (contains_illegal) {
        // if contains illegal characters,
        // must to be enclosed in double-quotes, otherwise it's not a valid display name
        if (display_name_without_quotes === display_name) return false;
         // the quotes in display name must start with character symbol \
        var all_start_with_back_slash = display_name_without_quotes.split('"').length === display_name_without_quotes.split('\\"').length;
        if (!all_start_with_back_slash) return false;
    }
    return true;
}
function $1007e3231928cbb8$export$2e2bcd8739ae039(str, options) {
    (0, $i0YFF.default)(str);
    options = (0, $SWroD.default)(options, $1007e3231928cbb8$var$default_email_options);
    if (options.require_display_name || options.allow_display_name) {
        var display_email = str.match($1007e3231928cbb8$var$splitNameAddress);
        if (display_email) {
            var display_name = display_email[1]; // Remove display name and angle brackets to get email address
            // Can be done in the regex but will introduce a ReDOS (See  #1597 for more info)
            str = str.replace(display_name, "").replace(/(^<|>$)/g, ""); // sometimes need to trim the last space to get the display name
            // because there may be a space between display name and email address
            // eg. myname <address@gmail.com>
            // the display name is `myname` instead of `myname `, so need to trim the last space
            if (display_name.endsWith(" ")) display_name = display_name.slice(0, -1);
            if (!$1007e3231928cbb8$var$validateDisplayName(display_name)) return false;
        } else if (options.require_display_name) return false;
    }
    if (!options.ignore_max_length && str.length > $1007e3231928cbb8$var$defaultMaxEmailLength) return false;
    var parts = str.split("@");
    var domain = parts.pop();
    var lower_domain = domain.toLowerCase();
    if (options.host_blacklist.includes(lower_domain)) return false;
    if (options.host_whitelist.length > 0 && !options.host_whitelist.includes(lower_domain)) return false;
    var user = parts.join("@");
    if (options.domain_specific_validation && (lower_domain === "gmail.com" || lower_domain === "googlemail.com")) {
        /*
      Previously we removed dots for gmail addresses before validating.
      This was removed because it allows `multiple..dots@gmail.com`
      to be reported as valid, but it is not.
      Gmail only normalizes single dots, removing them from here is pointless,
      should be done in normalizeEmail
    */ user = user.toLowerCase(); // Removing sub-address from username before gmail validation
        var username = user.split("+")[0]; // Dots are not included in gmail length restriction
        if (!(0, $8h7WX.default)(username.replace(/\./g, ""), {
            min: 6,
            max: 30
        })) return false;
        var _user_parts = username.split(".");
        for(var i = 0; i < _user_parts.length; i++){
            if (!$1007e3231928cbb8$var$gmailUserPart.test(_user_parts[i])) return false;
        }
    }
    if (options.ignore_max_length === false && (!(0, $8h7WX.default)(user, {
        max: 64
    }) || !(0, $8h7WX.default)(domain, {
        max: 254
    }))) return false;
    if (!(0, $aYOJs.default)(domain, {
        require_tld: options.require_tld,
        ignore_max_length: options.ignore_max_length
    })) {
        if (!options.allow_ip_domain) return false;
        if (!(0, $bIal2.default)(domain)) {
            if (!domain.startsWith("[") || !domain.endsWith("]")) return false;
            var noBracketdomain = domain.slice(1, -1);
            if (noBracketdomain.length === 0 || !(0, $bIal2.default)(noBracketdomain)) return false;
        }
    }
    if (user[0] === '"') {
        user = user.slice(1, user.length - 1);
        return options.allow_utf8_local_part ? $1007e3231928cbb8$var$quotedEmailUserUtf8.test(user) : $1007e3231928cbb8$var$quotedEmailUser.test(user);
    }
    var pattern = options.allow_utf8_local_part ? $1007e3231928cbb8$var$emailUserUtf8Part : $1007e3231928cbb8$var$emailUserPart;
    var user_parts = user.split(".");
    for(var _i = 0; _i < user_parts.length; _i++){
        if (!pattern.test(user_parts[_i])) return false;
    }
    if (options.blacklisted_chars) {
        if (user.search(new RegExp("[".concat(options.blacklisted_chars, "]+"), "g")) !== -1) return false;
    }
    return true;
}

});
parcelRequire.register("i0YFF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1d74a12f216232a$export$2e2bcd8739ae039; });
function $d1d74a12f216232a$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $d1d74a12f216232a$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $d1d74a12f216232a$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $d1d74a12f216232a$var$_typeof(obj);
}
function $d1d74a12f216232a$export$2e2bcd8739ae039(input) {
    var isString = typeof input === "string" || input instanceof String;
    if (!isString) {
        var invalidType = $d1d74a12f216232a$var$_typeof(input);
        if (input === null) invalidType = "null";
        else if (invalidType === "object") invalidType = input.constructor.name;
        throw new TypeError("Expected a string but received a ".concat(invalidType));
    }
}

});

parcelRequire.register("SWroD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a526066a8713c7b$export$2e2bcd8739ae039; });
function $0a526066a8713c7b$export$2e2bcd8739ae039() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var defaults = arguments.length > 1 ? arguments[1] : undefined;
    for(var key in defaults)if (typeof obj[key] === "undefined") obj[key] = defaults[key];
    return obj;
}

});

parcelRequire.register("8h7WX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $606613f430d0a054$export$2e2bcd8739ae039; });

var $i0YFF = parcelRequire("i0YFF");
function $606613f430d0a054$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $606613f430d0a054$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $606613f430d0a054$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $606613f430d0a054$var$_typeof(obj);
}
function $606613f430d0a054$export$2e2bcd8739ae039(str, options) {
    (0, $i0YFF.default)(str);
    var min;
    var max;
    if ($606613f430d0a054$var$_typeof(options) === "object") {
        min = options.min || 0;
        max = options.max;
    } else {
        // backwards compatibility: isByteLength(str, min [, max])
        min = arguments[1];
        max = arguments[2];
    }
    var len = encodeURI(str).split(/%..|./).length - 1;
    return len >= min && (typeof max === "undefined" || len <= max);
}

});

parcelRequire.register("aYOJs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7fe6dc53c33bdd41$export$2e2bcd8739ae039; });

var $i0YFF = parcelRequire("i0YFF");

var $SWroD = parcelRequire("SWroD");
var $7fe6dc53c33bdd41$var$default_fqdn_options = {
    require_tld: true,
    allow_underscores: false,
    allow_trailing_dot: false,
    allow_numeric_tld: false,
    allow_wildcard: false,
    ignore_max_length: false
};
function $7fe6dc53c33bdd41$export$2e2bcd8739ae039(str, options) {
    (0, $i0YFF.default)(str);
    options = (0, $SWroD.default)(options, $7fe6dc53c33bdd41$var$default_fqdn_options);
    /* Remove the optional trailing dot before checking validity */ if (options.allow_trailing_dot && str[str.length - 1] === ".") str = str.substring(0, str.length - 1);
    /* Remove the optional wildcard before checking validity */ if (options.allow_wildcard === true && str.indexOf("*.") === 0) str = str.substring(2);
    var parts = str.split(".");
    var tld = parts[parts.length - 1];
    if (options.require_tld) {
        // disallow fqdns without tld
        if (parts.length < 2) return false;
        if (!options.allow_numeric_tld && !/^([a-z\u00A1-\u00A8\u00AA-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) return false;
         // disallow spaces
        if (/\s/.test(tld)) return false;
    } // reject numeric TLDs
    if (!options.allow_numeric_tld && /^\d+$/.test(tld)) return false;
    return parts.every(function(part) {
        if (part.length > 63 && !options.ignore_max_length) return false;
        if (!/^[a-z_\u00a1-\uffff0-9-]+$/i.test(part)) return false;
         // disallow full-width chars
        if (/[\uff01-\uff5e]/.test(part)) return false;
         // disallow parts starting or ending with hyphen
        if (/^-|-$/.test(part)) return false;
        if (!options.allow_underscores && /_/.test(part)) return false;
        return true;
    });
}

});

parcelRequire.register("bIal2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $886bd2c40b215a74$export$2e2bcd8739ae039; });

var $i0YFF = parcelRequire("i0YFF");
/**
11.3.  Examples

   The following addresses

             fe80::1234 (on the 1st link of the node)
             ff02::5678 (on the 5th link of the node)
             ff08::9abc (on the 10th organization of the node)

   would be represented as follows:

             fe80::1234%1
             ff02::5678%5
             ff08::9abc%10

   (Here we assume a natural translation from a zone index to the
   <zone_id> part, where the Nth zone of any scope is translated into
   "N".)

   If we use interface names as <zone_id>, those addresses could also be
   represented as follows:

            fe80::1234%ne0
            ff02::5678%pvc1.3
            ff08::9abc%interface10

   where the interface "ne0" belongs to the 1st link, "pvc1.3" belongs
   to the 5th link, and "interface10" belongs to the 10th organization.
 * * */ var $886bd2c40b215a74$var$IPv4SegmentFormat = "(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])";
var $886bd2c40b215a74$var$IPv4AddressFormat = "(".concat($886bd2c40b215a74$var$IPv4SegmentFormat, "[.]){3}").concat($886bd2c40b215a74$var$IPv4SegmentFormat);
var $886bd2c40b215a74$var$IPv4AddressRegExp = new RegExp("^".concat($886bd2c40b215a74$var$IPv4AddressFormat, "$"));
var $886bd2c40b215a74$var$IPv6SegmentFormat = "(?:[0-9a-fA-F]{1,4})";
var $886bd2c40b215a74$var$IPv6AddressRegExp = new RegExp("^(" + "(?:".concat($886bd2c40b215a74$var$IPv6SegmentFormat, ":){7}(?:").concat($886bd2c40b215a74$var$IPv6SegmentFormat, "|:)|") + "(?:".concat($886bd2c40b215a74$var$IPv6SegmentFormat, ":){6}(?:").concat($886bd2c40b215a74$var$IPv4AddressFormat, "|:").concat($886bd2c40b215a74$var$IPv6SegmentFormat, "|:)|") + "(?:".concat($886bd2c40b215a74$var$IPv6SegmentFormat, ":){5}(?::").concat($886bd2c40b215a74$var$IPv4AddressFormat, "|(:").concat($886bd2c40b215a74$var$IPv6SegmentFormat, "){1,2}|:)|") + "(?:".concat($886bd2c40b215a74$var$IPv6SegmentFormat, ":){4}(?:(:").concat($886bd2c40b215a74$var$IPv6SegmentFormat, "){0,1}:").concat($886bd2c40b215a74$var$IPv4AddressFormat, "|(:").concat($886bd2c40b215a74$var$IPv6SegmentFormat, "){1,3}|:)|") + "(?:".concat($886bd2c40b215a74$var$IPv6SegmentFormat, ":){3}(?:(:").concat($886bd2c40b215a74$var$IPv6SegmentFormat, "){0,2}:").concat($886bd2c40b215a74$var$IPv4AddressFormat, "|(:").concat($886bd2c40b215a74$var$IPv6SegmentFormat, "){1,4}|:)|") + "(?:".concat($886bd2c40b215a74$var$IPv6SegmentFormat, ":){2}(?:(:").concat($886bd2c40b215a74$var$IPv6SegmentFormat, "){0,3}:").concat($886bd2c40b215a74$var$IPv4AddressFormat, "|(:").concat($886bd2c40b215a74$var$IPv6SegmentFormat, "){1,5}|:)|") + "(?:".concat($886bd2c40b215a74$var$IPv6SegmentFormat, ":){1}(?:(:").concat($886bd2c40b215a74$var$IPv6SegmentFormat, "){0,4}:").concat($886bd2c40b215a74$var$IPv4AddressFormat, "|(:").concat($886bd2c40b215a74$var$IPv6SegmentFormat, "){1,6}|:)|") + "(?::((?::".concat($886bd2c40b215a74$var$IPv6SegmentFormat, "){0,5}:").concat($886bd2c40b215a74$var$IPv4AddressFormat, "|(?::").concat($886bd2c40b215a74$var$IPv6SegmentFormat, "){1,7}|:))") + ")(%[0-9a-zA-Z-.:]{1,})?$");
function $886bd2c40b215a74$export$2e2bcd8739ae039(str) {
    var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    (0, $i0YFF.default)(str);
    version = String(version);
    if (!version) return $886bd2c40b215a74$export$2e2bcd8739ae039(str, 4) || $886bd2c40b215a74$export$2e2bcd8739ae039(str, 6);
    if (version === "4") return $886bd2c40b215a74$var$IPv4AddressRegExp.test(str);
    if (version === "6") return $886bd2c40b215a74$var$IPv6AddressRegExp.test(str);
    return false;
}

});


parcelRequire.register("9k9RZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01c07a5fe8e33713$export$2e2bcd8739ae039; });

var $i0YFF = parcelRequire("i0YFF");

var $SWroD = parcelRequire("SWroD");
var $01c07a5fe8e33713$var$default_is_empty_options = {
    ignore_whitespace: false
};
function $01c07a5fe8e33713$export$2e2bcd8739ae039(str, options) {
    (0, $i0YFF.default)(str);
    options = (0, $SWroD.default)(options, $01c07a5fe8e33713$var$default_is_empty_options);
    return (options.ignore_whitespace ? str.trim().length : str.length) === 0;
}

});

parcelRequire.register("eaU57", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a51d8081ef691a91$export$2e2bcd8739ae039; });

var $i0YFF = parcelRequire("i0YFF");

var $aYOJs = parcelRequire("aYOJs");

var $bIal2 = parcelRequire("bIal2");

var $SWroD = parcelRequire("SWroD");
function $a51d8081ef691a91$var$_slicedToArray(arr, i) {
    return $a51d8081ef691a91$var$_arrayWithHoles(arr) || $a51d8081ef691a91$var$_iterableToArrayLimit(arr, i) || $a51d8081ef691a91$var$_unsupportedIterableToArray(arr, i) || $a51d8081ef691a91$var$_nonIterableRest();
}
function $a51d8081ef691a91$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a51d8081ef691a91$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a51d8081ef691a91$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a51d8081ef691a91$var$_arrayLikeToArray(o, minLen);
}
function $a51d8081ef691a91$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a51d8081ef691a91$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $a51d8081ef691a91$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
/*
options for isURL method

require_protocol - if set as true isURL will return false if protocol is not present in the URL
require_valid_protocol - isURL will check if the URL's protocol is present in the protocols option
protocols - valid protocols can be modified with this option
require_host - if set as false isURL will not check if host is present in the URL
require_port - if set as true isURL will check if port is present in the URL
allow_protocol_relative_urls - if set as true protocol relative URLs will be allowed
validate_length - if set as false isURL will skip string length validation (IE maximum is 2083)

*/ var $a51d8081ef691a91$var$default_url_options = {
    protocols: [
        "http",
        "https",
        "ftp"
    ],
    require_tld: true,
    require_protocol: false,
    require_host: true,
    require_port: false,
    require_valid_protocol: true,
    allow_underscores: false,
    allow_trailing_dot: false,
    allow_protocol_relative_urls: false,
    allow_fragments: true,
    allow_query_components: true,
    validate_length: true
};
var $a51d8081ef691a91$var$wrapped_ipv6 = /^\[([^\]]+)\](?::([0-9]+))?$/;
function $a51d8081ef691a91$var$isRegExp(obj) {
    return Object.prototype.toString.call(obj) === "[object RegExp]";
}
function $a51d8081ef691a91$var$checkHost(host, matches) {
    for(var i = 0; i < matches.length; i++){
        var match = matches[i];
        if (host === match || $a51d8081ef691a91$var$isRegExp(match) && match.test(host)) return true;
    }
    return false;
}
function $a51d8081ef691a91$export$2e2bcd8739ae039(url, options) {
    (0, $i0YFF.default)(url);
    if (!url || /[\s<>]/.test(url)) return false;
    if (url.indexOf("mailto:") === 0) return false;
    options = (0, $SWroD.default)(options, $a51d8081ef691a91$var$default_url_options);
    if (options.validate_length && url.length >= 2083) return false;
    if (!options.allow_fragments && url.includes("#")) return false;
    if (!options.allow_query_components && (url.includes("?") || url.includes("&"))) return false;
    var protocol, auth, host, hostname, port, port_str, split, ipv6;
    split = url.split("#");
    url = split.shift();
    split = url.split("?");
    url = split.shift();
    split = url.split("://");
    if (split.length > 1) {
        protocol = split.shift().toLowerCase();
        if (options.require_valid_protocol && options.protocols.indexOf(protocol) === -1) return false;
    } else if (options.require_protocol) return false;
    else if (url.slice(0, 2) === "//") {
        if (!options.allow_protocol_relative_urls) return false;
        split[0] = url.slice(2);
    }
    url = split.join("://");
    if (url === "") return false;
    split = url.split("/");
    url = split.shift();
    if (url === "" && !options.require_host) return true;
    split = url.split("@");
    if (split.length > 1) {
        if (options.disallow_auth) return false;
        if (split[0] === "") return false;
        auth = split.shift();
        if (auth.indexOf(":") >= 0 && auth.split(":").length > 2) return false;
        var _auth$split = auth.split(":"), _auth$split2 = $a51d8081ef691a91$var$_slicedToArray(_auth$split, 2), user = _auth$split2[0], password = _auth$split2[1];
        if (user === "" && password === "") return false;
    }
    hostname = split.join("@");
    port_str = null;
    ipv6 = null;
    var ipv6_match = hostname.match($a51d8081ef691a91$var$wrapped_ipv6);
    if (ipv6_match) {
        host = "";
        ipv6 = ipv6_match[1];
        port_str = ipv6_match[2] || null;
    } else {
        split = hostname.split(":");
        host = split.shift();
        if (split.length) port_str = split.join(":");
    }
    if (port_str !== null && port_str.length > 0) {
        port = parseInt(port_str, 10);
        if (!/^[0-9]+$/.test(port_str) || port <= 0 || port > 65535) return false;
    } else if (options.require_port) return false;
    if (options.host_whitelist) return $a51d8081ef691a91$var$checkHost(host, options.host_whitelist);
    if (host === "" && !options.require_host) return true;
    if (!(0, $bIal2.default)(host) && !(0, $aYOJs.default)(host, options) && (!ipv6 || !(0, $bIal2.default)(ipv6, 6))) return false;
    host = host || ipv6;
    if (options.host_blacklist && $a51d8081ef691a91$var$checkHost(host, options.host_blacklist)) return false;
    return true;
}

});

parcelRequire.register("buU2k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $85edf6c070947bec$export$2e2bcd8739ae039; });

var $i0YFF = parcelRequire("i0YFF");

var $lu3lS = parcelRequire("lu3lS");
function $85edf6c070947bec$export$2e2bcd8739ae039(str, options) {
    (0, $i0YFF.default)(str);
    options = options || {};
    var _float = new RegExp("^(?:[-+])?(?:[0-9]+)?(?:\\".concat(options.locale ? (0, $lu3lS.decimal)[options.locale] : ".", "[0-9]*)?(?:[eE][\\+\\-]?(?:[0-9]+))?$"));
    if (str === "" || str === "." || str === "," || str === "-" || str === "+") return false;
    var value = parseFloat(str.replace(",", "."));
    return _float.test(str) && (!options.hasOwnProperty("min") || value >= options.min) && (!options.hasOwnProperty("max") || value <= options.max) && (!options.hasOwnProperty("lt") || value < options.lt) && (!options.hasOwnProperty("gt") || value > options.gt);
}
var $85edf6c070947bec$export$df1c34db1371eeed = Object.keys((0, $lu3lS.decimal));

});
parcelRequire.register("lu3lS", function(module, exports) {

$parcel$export(module.exports, "decimal", function () { return $fa3efff2219ff911$export$78a48a3d1e5dbe89; });
var $fa3efff2219ff911$export$58f0f39f63f3cf42 = {
    "en-US": /^[A-Z]+$/i,
    "az-AZ": /^[A-VXYZÇƏĞİıÖŞÜ]+$/i,
    "bg-BG": /^[А-Я]+$/i,
    "cs-CZ": /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
    "da-DK": /^[A-ZÆØÅ]+$/i,
    "de-DE": /^[A-ZÄÖÜß]+$/i,
    "el-GR": /^[Α-ώ]+$/i,
    "es-ES": /^[A-ZÁÉÍÑÓÚÜ]+$/i,
    "fa-IR": /^[ابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهی]+$/i,
    "fi-FI": /^[A-ZÅÄÖ]+$/i,
    "fr-FR": /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
    "it-IT": /^[A-ZÀÉÈÌÎÓÒÙ]+$/i,
    "ja-JP": /^[ぁ-んァ-ヶｦ-ﾟ一-龠ー・。、]+$/i,
    "nb-NO": /^[A-ZÆØÅ]+$/i,
    "nl-NL": /^[A-ZÁÉËÏÓÖÜÚ]+$/i,
    "nn-NO": /^[A-ZÆØÅ]+$/i,
    "hu-HU": /^[A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
    "pl-PL": /^[A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
    "pt-PT": /^[A-ZÃÁÀÂÄÇÉÊËÍÏÕÓÔÖÚÜ]+$/i,
    "ru-RU": /^[А-ЯЁ]+$/i,
    "sl-SI": /^[A-ZČĆĐŠŽ]+$/i,
    "sk-SK": /^[A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
    "sr-RS@latin": /^[A-ZČĆŽŠĐ]+$/i,
    "sr-RS": /^[А-ЯЂЈЉЊЋЏ]+$/i,
    "sv-SE": /^[A-ZÅÄÖ]+$/i,
    "th-TH": /^[ก-๐\s]+$/i,
    "tr-TR": /^[A-ZÇĞİıÖŞÜ]+$/i,
    "uk-UA": /^[А-ЩЬЮЯЄIЇҐі]+$/i,
    "vi-VN": /^[A-ZÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴĐÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸ]+$/i,
    "ko-KR": /^[ㄱ-ㅎㅏ-ㅣ가-힣]*$/,
    "ku-IQ": /^[ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
    ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/,
    he: /^[א-ת]+$/,
    fa: /^['آاءأؤئبپتثجچحخدذرزژسشصضطظعغفقکگلمنوهةی']+$/i,
    bn: /^['ঀঁংঃঅআইঈউঊঋঌএঐওঔকখগঘঙচছজঝঞটঠডঢণতথদধনপফবভমযরলশষসহ়ঽািীুূৃৄেৈোৌ্ৎৗড়ঢ়য়ৠৡৢৣৰৱ৲৳৴৵৶৷৸৹৺৻']+$/,
    "hi-IN": /^[\u0900-\u0961]+[\u0972-\u097F]*$/i,
    "si-LK": /^[\u0D80-\u0DFF]+$/
};
var $fa3efff2219ff911$export$ec6fd95514ae461e = {
    "en-US": /^[0-9A-Z]+$/i,
    "az-AZ": /^[0-9A-VXYZÇƏĞİıÖŞÜ]+$/i,
    "bg-BG": /^[0-9А-Я]+$/i,
    "cs-CZ": /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
    "da-DK": /^[0-9A-ZÆØÅ]+$/i,
    "de-DE": /^[0-9A-ZÄÖÜß]+$/i,
    "el-GR": /^[0-9Α-ω]+$/i,
    "es-ES": /^[0-9A-ZÁÉÍÑÓÚÜ]+$/i,
    "fi-FI": /^[0-9A-ZÅÄÖ]+$/i,
    "fr-FR": /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
    "it-IT": /^[0-9A-ZÀÉÈÌÎÓÒÙ]+$/i,
    "ja-JP": /^[0-9０-９ぁ-んァ-ヶｦ-ﾟ一-龠ー・。、]+$/i,
    "hu-HU": /^[0-9A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
    "nb-NO": /^[0-9A-ZÆØÅ]+$/i,
    "nl-NL": /^[0-9A-ZÁÉËÏÓÖÜÚ]+$/i,
    "nn-NO": /^[0-9A-ZÆØÅ]+$/i,
    "pl-PL": /^[0-9A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
    "pt-PT": /^[0-9A-ZÃÁÀÂÄÇÉÊËÍÏÕÓÔÖÚÜ]+$/i,
    "ru-RU": /^[0-9А-ЯЁ]+$/i,
    "sl-SI": /^[0-9A-ZČĆĐŠŽ]+$/i,
    "sk-SK": /^[0-9A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
    "sr-RS@latin": /^[0-9A-ZČĆŽŠĐ]+$/i,
    "sr-RS": /^[0-9А-ЯЂЈЉЊЋЏ]+$/i,
    "sv-SE": /^[0-9A-ZÅÄÖ]+$/i,
    "th-TH": /^[ก-๙\s]+$/i,
    "tr-TR": /^[0-9A-ZÇĞİıÖŞÜ]+$/i,
    "uk-UA": /^[0-9А-ЩЬЮЯЄIЇҐі]+$/i,
    "ko-KR": /^[0-9ㄱ-ㅎㅏ-ㅣ가-힣]*$/,
    "ku-IQ": /^[٠١٢٣٤٥٦٧٨٩0-9ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
    "vi-VN": /^[0-9A-ZÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴĐÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸ]+$/i,
    ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/,
    he: /^[0-9א-ת]+$/,
    fa: /^['0-9آاءأؤئبپتثجچحخدذرزژسشصضطظعغفقکگلمنوهةی۱۲۳۴۵۶۷۸۹۰']+$/i,
    bn: /^['ঀঁংঃঅআইঈউঊঋঌএঐওঔকখগঘঙচছজঝঞটঠডঢণতথদধনপফবভমযরলশষসহ়ঽািীুূৃৄেৈোৌ্ৎৗড়ঢ়য়ৠৡৢৣ০১২৩৪৫৬৭৮৯ৰৱ৲৳৴৵৶৷৸৹৺৻']+$/,
    "hi-IN": /^[\u0900-\u0963]+[\u0966-\u097F]*$/i,
    "si-LK": /^[0-9\u0D80-\u0DFF]+$/
};
var $fa3efff2219ff911$export$78a48a3d1e5dbe89 = {
    "en-US": ".",
    ar: "٫"
};
var $fa3efff2219ff911$export$53d0e1e468367297 = [
    "AU",
    "GB",
    "HK",
    "IN",
    "NZ",
    "ZA",
    "ZM"
];
for(var $fa3efff2219ff911$var$locale, $fa3efff2219ff911$var$i = 0; $fa3efff2219ff911$var$i < $fa3efff2219ff911$export$53d0e1e468367297.length; $fa3efff2219ff911$var$i++){
    $fa3efff2219ff911$var$locale = "en-".concat($fa3efff2219ff911$export$53d0e1e468367297[$fa3efff2219ff911$var$i]);
    $fa3efff2219ff911$export$58f0f39f63f3cf42[$fa3efff2219ff911$var$locale] = $fa3efff2219ff911$export$58f0f39f63f3cf42["en-US"];
    $fa3efff2219ff911$export$ec6fd95514ae461e[$fa3efff2219ff911$var$locale] = $fa3efff2219ff911$export$ec6fd95514ae461e["en-US"];
    $fa3efff2219ff911$export$78a48a3d1e5dbe89[$fa3efff2219ff911$var$locale] = $fa3efff2219ff911$export$78a48a3d1e5dbe89["en-US"];
} // Source: http://www.localeplanet.com/java/
var $fa3efff2219ff911$export$58f204249da57b9f = [
    "AE",
    "BH",
    "DZ",
    "EG",
    "IQ",
    "JO",
    "KW",
    "LB",
    "LY",
    "MA",
    "QM",
    "QA",
    "SA",
    "SD",
    "SY",
    "TN",
    "YE"
];
for(var $fa3efff2219ff911$var$_locale, $fa3efff2219ff911$var$_i = 0; $fa3efff2219ff911$var$_i < $fa3efff2219ff911$export$58f204249da57b9f.length; $fa3efff2219ff911$var$_i++){
    $fa3efff2219ff911$var$_locale = "ar-".concat($fa3efff2219ff911$export$58f204249da57b9f[$fa3efff2219ff911$var$_i]);
    $fa3efff2219ff911$export$58f0f39f63f3cf42[$fa3efff2219ff911$var$_locale] = $fa3efff2219ff911$export$58f0f39f63f3cf42.ar;
    $fa3efff2219ff911$export$ec6fd95514ae461e[$fa3efff2219ff911$var$_locale] = $fa3efff2219ff911$export$ec6fd95514ae461e.ar;
    $fa3efff2219ff911$export$78a48a3d1e5dbe89[$fa3efff2219ff911$var$_locale] = $fa3efff2219ff911$export$78a48a3d1e5dbe89.ar;
}
var $fa3efff2219ff911$export$68e7f6e895cd29a3 = [
    "IR",
    "AF"
];
for(var $fa3efff2219ff911$var$_locale2, $fa3efff2219ff911$var$_i2 = 0; $fa3efff2219ff911$var$_i2 < $fa3efff2219ff911$export$68e7f6e895cd29a3.length; $fa3efff2219ff911$var$_i2++){
    $fa3efff2219ff911$var$_locale2 = "fa-".concat($fa3efff2219ff911$export$68e7f6e895cd29a3[$fa3efff2219ff911$var$_i2]);
    $fa3efff2219ff911$export$ec6fd95514ae461e[$fa3efff2219ff911$var$_locale2] = $fa3efff2219ff911$export$ec6fd95514ae461e.fa;
    $fa3efff2219ff911$export$78a48a3d1e5dbe89[$fa3efff2219ff911$var$_locale2] = $fa3efff2219ff911$export$78a48a3d1e5dbe89.ar;
}
var $fa3efff2219ff911$export$c743837ea6a7e716 = [
    "BD",
    "IN"
];
for(var $fa3efff2219ff911$var$_locale3, $fa3efff2219ff911$var$_i3 = 0; $fa3efff2219ff911$var$_i3 < $fa3efff2219ff911$export$c743837ea6a7e716.length; $fa3efff2219ff911$var$_i3++){
    $fa3efff2219ff911$var$_locale3 = "bn-".concat($fa3efff2219ff911$export$c743837ea6a7e716[$fa3efff2219ff911$var$_i3]);
    $fa3efff2219ff911$export$58f0f39f63f3cf42[$fa3efff2219ff911$var$_locale3] = $fa3efff2219ff911$export$58f0f39f63f3cf42.bn;
    $fa3efff2219ff911$export$ec6fd95514ae461e[$fa3efff2219ff911$var$_locale3] = $fa3efff2219ff911$export$ec6fd95514ae461e.bn;
    $fa3efff2219ff911$export$78a48a3d1e5dbe89[$fa3efff2219ff911$var$_locale3] = $fa3efff2219ff911$export$78a48a3d1e5dbe89["en-US"];
} // Source: https://en.wikipedia.org/wiki/Decimal_mark
var $fa3efff2219ff911$export$e6e6bb5a6888bacd = [
    "ar-EG",
    "ar-LB",
    "ar-LY"
];
var $fa3efff2219ff911$export$27c2f17ea18816a0 = [
    "bg-BG",
    "cs-CZ",
    "da-DK",
    "de-DE",
    "el-GR",
    "en-ZM",
    "es-ES",
    "fr-CA",
    "fr-FR",
    "id-ID",
    "it-IT",
    "ku-IQ",
    "hi-IN",
    "hu-HU",
    "nb-NO",
    "nn-NO",
    "nl-NL",
    "pl-PL",
    "pt-PT",
    "ru-RU",
    "si-LK",
    "sl-SI",
    "sr-RS@latin",
    "sr-RS",
    "sv-SE",
    "tr-TR",
    "uk-UA",
    "vi-VN"
];
for(var $fa3efff2219ff911$var$_i4 = 0; $fa3efff2219ff911$var$_i4 < $fa3efff2219ff911$export$e6e6bb5a6888bacd.length; $fa3efff2219ff911$var$_i4++)$fa3efff2219ff911$export$78a48a3d1e5dbe89[$fa3efff2219ff911$export$e6e6bb5a6888bacd[$fa3efff2219ff911$var$_i4]] = $fa3efff2219ff911$export$78a48a3d1e5dbe89["en-US"];
for(var $fa3efff2219ff911$var$_i5 = 0; $fa3efff2219ff911$var$_i5 < $fa3efff2219ff911$export$27c2f17ea18816a0.length; $fa3efff2219ff911$var$_i5++)$fa3efff2219ff911$export$78a48a3d1e5dbe89[$fa3efff2219ff911$export$27c2f17ea18816a0[$fa3efff2219ff911$var$_i5]] = ",";
$fa3efff2219ff911$export$58f0f39f63f3cf42["fr-CA"] = $fa3efff2219ff911$export$58f0f39f63f3cf42["fr-FR"];
$fa3efff2219ff911$export$ec6fd95514ae461e["fr-CA"] = $fa3efff2219ff911$export$ec6fd95514ae461e["fr-FR"];
$fa3efff2219ff911$export$58f0f39f63f3cf42["pt-BR"] = $fa3efff2219ff911$export$58f0f39f63f3cf42["pt-PT"];
$fa3efff2219ff911$export$ec6fd95514ae461e["pt-BR"] = $fa3efff2219ff911$export$ec6fd95514ae461e["pt-PT"];
$fa3efff2219ff911$export$78a48a3d1e5dbe89["pt-BR"] = $fa3efff2219ff911$export$78a48a3d1e5dbe89["pt-PT"]; // see #862
$fa3efff2219ff911$export$58f0f39f63f3cf42["pl-Pl"] = $fa3efff2219ff911$export$58f0f39f63f3cf42["pl-PL"];
$fa3efff2219ff911$export$ec6fd95514ae461e["pl-Pl"] = $fa3efff2219ff911$export$ec6fd95514ae461e["pl-PL"];
$fa3efff2219ff911$export$78a48a3d1e5dbe89["pl-Pl"] = $fa3efff2219ff911$export$78a48a3d1e5dbe89["pl-PL"]; // see #1455
$fa3efff2219ff911$export$58f0f39f63f3cf42["fa-AF"] = $fa3efff2219ff911$export$58f0f39f63f3cf42.fa;

});


parcelRequire.register("aSG46", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ebf93c692b7d28d$export$2e2bcd8739ae039; });

var $i0YFF = parcelRequire("i0YFF");
var $7ebf93c692b7d28d$var$_int = /^(?:[-+]?(?:0|[1-9][0-9]*))$/;
var $7ebf93c692b7d28d$var$intLeadingZeroes = /^[-+]?[0-9]+$/;
function $7ebf93c692b7d28d$export$2e2bcd8739ae039(str, options) {
    (0, $i0YFF.default)(str);
    options = options || {}; // Get the regex to use for testing, based on whether
    // leading zeroes are allowed or not.
    var regex = options.hasOwnProperty("allow_leading_zeroes") && !options.allow_leading_zeroes ? $7ebf93c692b7d28d$var$_int : $7ebf93c692b7d28d$var$intLeadingZeroes; // Check min/max/lt/gt
    var minCheckPassed = !options.hasOwnProperty("min") || str >= options.min;
    var maxCheckPassed = !options.hasOwnProperty("max") || str <= options.max;
    var ltCheckPassed = !options.hasOwnProperty("lt") || str < options.lt;
    var gtCheckPassed = !options.hasOwnProperty("gt") || str > options.gt;
    return regex.test(str) && minCheckPassed && maxCheckPassed && ltCheckPassed && gtCheckPassed;
}

});


parcelRequire.register("cH8J9", function(module, exports) {

$parcel$export(module.exports, "renderErrorMessage", function () { return $93e0453f35bbc687$export$4ecbf1a4dd88f65f; });
const $93e0453f35bbc687$export$4ecbf1a4dd88f65f = (message)=>{
    const noticeWrap = document.createElement("div");
    noticeWrap.classList.add("validator");
    const notice = document.createElement("span");
    notice.innerHTML = message;
    notice.classList.add("erorr-s");
    noticeWrap.appendChild(notice);
    return noticeWrap;
};

});


parcelRequire.register("3tZrP", function(module, exports) {

var $cH8J9 = parcelRequire("cH8J9");

var $1oeMt = parcelRequire("1oeMt");
const $2893beced4b70269$var$inputsToValidate = document.querySelectorAll("[data-validators]");
const $2893beced4b70269$var$isInputsToValidate = ()=>$2893beced4b70269$var$inputsToValidate.length;
if ($2893beced4b70269$var$isInputsToValidate()) $2893beced4b70269$var$inputsToValidate.forEach((input)=>{
    input.addEventListener("input", ()=>{
        const validatorsData = JSON.parse(input.getAttribute("data-validators"));
        validatorsData.forEach((validator)=>{
            const validatorMessage = input.parentNode.querySelector(".validator");
            if (validatorMessage !== null) validatorMessage.remove();
            input.closest(".f-text")?.classList.remove("--invalid");
            const { msg: msg = "" } = validator;
            const inputValue = input.value;
            const result = (0, $1oeMt.validateHandle)(validator, inputValue);
            if (!result) {
                input.after((0, $cH8J9.renderErrorMessage)(msg));
                input.closest(".f-text")?.classList.add("--invalid");
            }
        });
    });
});

});


})();
//# sourceMappingURL=form-validation.9cdfcfdd.js.map
